module.exports = __webpack_public_path__ + "static/SGWB-reglement-7aaf78a48764d52c3d19d5d2b8fcc0ef.pdf";